import { render, staticRenderFns } from "./calendar-header.vue?vue&type=template&id=9bdf279e"
import script from "./calendar-header.vue?vue&type=script&lang=js"
export * from "./calendar-header.vue?vue&type=script&lang=js"
import style0 from "./calendar-header.vue?vue&type=style&index=0&id=9bdf279e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports